"use client";

import { useEffect } from "react";

import api from "@/api";
import { PostResponseType } from "@/types/post";

interface PostViewCounterProps {
  postId: PostResponseType["id"];
  postSlug?: string;
  postTitle?: string;
}

function PostViewCounter({ postId }: PostViewCounterProps) {
  useEffect(() => {
    api.post.addView(postId);
  }, [postId]);

  return null;
}

export default PostViewCounter;
